import React, { Component } from 'react';
import './SearchBar.css';
import getYelpBusinessInfo from '../../utils/YelpAPI';
import BusinessCard from '../business/BusinessCard'

class SearchBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeClass: 'Best Match',
            searchBusiness: '',
            searchLocation: '',
            results: [],
        };
    }

    activeMenu = (menuName) => {
        console.log(`Clicked on ${menuName}`);
        this.setState({ activeClass: menuName });
    };

    handleInputChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    };

    handleSubmit = async (event) => {
        event.preventDefault(); // Prevent form submission and page refresh

        const { activeClass, searchBusiness, searchLocation } = this.state;

        if (!searchBusiness || !searchLocation) {
            alert('You need to enter a Search term and Location');
            return; // don't proceed if fields are missing.
        }

        console.log('Active Class:', activeClass);
        console.log('Search Business:', searchBusiness);
        console.log('Search Location:', searchLocation);

        // Call the async function and await its result
        const results = await getYelpBusinessInfo(searchLocation, searchBusiness);

        // Organize results
        const yelpResults = results.map((result) => ( {
            name: result.name,
            id: result.id,
            image_url: result.image_url,
            address: result.location.address1,
            city: result.location.city,
            state: result.state,
            zipCode: result.location.zip_code,
            category: result.categories[0].title,
            rating: result.rating,
            reviewCount: result.review_count,
        }))
        console.log('Yelp Simplified Resutls: ', yelpResults);

        // Set the 'results' in the component state
        this.setState({ results: yelpResults });
        // After setting the results in your handleSubmit function, call the function to pass the results back to the parent component (App.js)
        this.props.updateResults(yelpResults);

    };

    render() {
        const { activeClass, searchBusiness, searchLocation, results } = this.state;

        return (
            <div className="search-hero">
                <div className="search sort">
                    <p
                        onClick={() => this.activeMenu('Best Match')}
                        className={activeClass === 'Best Match' ? 'active' : ''}
                    >
                        Best Match
                    </p>
                    <p
                        onClick={() => this.activeMenu('Highest Rated')}
                        className={activeClass === 'Highest Rated' ? 'active' : ''}
                    >
                        Highest Rated
                    </p>
                    <p
                        onClick={() => this.activeMenu('Most Reviewed')}
                        className={activeClass === 'Most Reviewed' ? 'active' : ''}
                    >
                        Most Reviewed
                    </p>
                </div>
                <form onSubmit={this.handleSubmit}>
                    <label className="search-fields">
                        <input
                            name="searchBusiness"
                            placeholder="Search Businesses"
                            value={searchBusiness}
                            onChange={this.handleInputChange}
                        />
                        <input
                            name="searchLocation"
                            placeholder="Location"
                            value={searchLocation}
                            onChange={this.handleInputChange}
                        />
                    </label>
                    <button type="submit">Let's go!</button>
                </form>
                {/* Pass the 'results' prop to the BusinessCard component */}
                {/*<BusinessCard results={results} />*/}
            </div>
        );
    }
}

export default SearchBar;
